<template>
  <page-section class="newsletter" :backgroundColor="backgroundColor || null">
    <div class="newsletter_container">
      <form
        method="POST"
        action="https://nederlandsmijnmuseum.activehosted.com/proc.php"
        id="_form_2_"
        class="_form _form_2 _inline-form _dark"
        novalidate
      >
        <input type="hidden" name="u" value="2" />
        <input type="hidden" name="f" value="2" />
        <input type="hidden" name="s" />
        <input type="hidden" name="c" value="0" />
        <input type="hidden" name="m" value="0" />
        <input type="hidden" name="act" value="sub" />
        <input type="hidden" name="v" value="2" />
        <div class="_form-content">
          <div class="_form_element _x63072452 _full_width">
            <label class="_form-label"> Naam </label>
            <div class="_field-wrapper">
              <input
                type="text"
                name="fullname"
                placeholder=""
                autocomplete="off"
              />
            </div>
          </div>
          <div class="_form_element _x72882802 _full_width">
            <label class="_form-label"> E-mailadres </label>
            <div class="_field-wrapper">
              <input
                type="text"
                name="email"
                placeholder=""
                required
                autocomplete="off"
              />
            </div>
          </div>
          <div class="_form_element">
            <ButtonLink
              @click="submitForm"
              class="newsletter_submitbutton"
              label="Inschrijven"
              href="#"
              :color="
                backgroundColor && backgroundColor === 'black' ? 'yellow' : null
              "
            />
          </div>

          <div class="_button-wrapper _full_width">
            <button id="_form_2_submit" class="_submit" type="submit">
              Verzend
            </button>
          </div>
          <div class="_clear-element"></div>
        </div>
        <div class="_form-thank-you" style="display: none"></div>
      </form>
    </div>
  </page-section>
</template>
<script src="./ContentblockNewsletter.js" lang="js" />
<style src="./ContentblockNewsletter.scss" lang="scss" scoped />
